import { useContext, useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";
import { showToast } from "../../showTost";
import { formatIstDateTime } from "../../utils/datetime";

export default function Notifications() {
  const { ApiBaseUrl, setIsLoginShow } = useContext(MyContext);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const Userid = secureLocalStorage.getItem("Userid");

  const load = () => {
    if (!Userid) {
      setIsLoginShow(true);
      setLoading(false);
      return;
    }
    setLoading(true);
    axios
      .post(`${ApiBaseUrl}/customer/notification_list`, { id: Userid })
      .then((r) => setList(r.data.nlist || []))
      .catch(() => showToast({ title: "Could not load notifications", id: "error" }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [Userid, ApiBaseUrl]);

  const markRead = (notificationId) => {
    axios
      .post(`${ApiBaseUrl}/customer/mark_notification_read`, {
        id: Userid,
        ...(notificationId ? { notification_id: notificationId } : {}),
      })
      .then(() => load())
      .catch(() => {});
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-rm-ink">Notifications</h1>
          <p className="text-gray-600 text-sm">Updates from appointments, labs and orders.</p>
        </div>
        {list.length > 0 && (
          <button className="text-sm text-[#0d9488] font-medium" onClick={() => markRead(null)}>
            Mark all read
          </button>
        )}
      </div>

      {loading ? (
        <p className="text-center text-gray-500 py-10">Loading…</p>
      ) : list.length === 0 ? (
        <div className="text-center py-16 border rounded-xl bg-white">
          <p className="font-medium text-lg">No notifications</p>
          <p className="text-gray-500 mt-1">You’re all caught up.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {list.map((n) => {
            const unread = String(n.is_read) !== "1";
            return (
              <button
                key={n.id}
                type="button"
                className={`w-full text-left border rounded-xl p-4 bg-white ${unread ? "border-orange-200 bg-orange-50/40" : ""}`}
                onClick={() => unread && markRead(n.id)}
              >
                <div className="flex justify-between gap-3">
                  <div>
                    <p className="font-medium">{n.title || n.service_uname || "Update"}</p>
                    <p className="text-sm text-gray-600 mt-1">{n.message || n.msg || n.description}</p>
                    {(n.date || n.created_at) && (
                      <p className="text-xs text-gray-400 mt-2">{formatIstDateTime(n.created_at || n.date) || n.date || n.created_at}</p>
                    )}
                  </div>
                  {unread && <span className="w-2 h-2 mt-2 rounded-full bg-[#0d9488] shrink-0" />}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
